// extracted by mini-css-extract-plugin
export default {"absoluteSelected":"absoluteSelected---HfaKl","orAnd":"orAnd---E5VRM"};